import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "src/redux/reducers";
import AddAIBriefPane from "./AddAIBriefPane";
import {
  setOpenAddBriefPaneForNewProject,
  setBriefDataForNewProject,
  setLoadingBriefForNewProject,
} from "src/redux/main/mainActions";
import { uploadBriefForNewProject } from "./utils";

export default function AddAIBriefPaneNewProject() {
  const {
    isOpenAddBriefPaneForNewProject,
    activeWorkspaceUuid,
    newProjectBriefData,
    isNewProjectBriefLoading,
  } = useSelector((state: RootState) => state.mainReducer);
  const dispatch = useDispatch();

  if (!isOpenAddBriefPaneForNewProject) return null;

  const handleCloseAddAIBriefPane = () => {
    dispatch(setOpenAddBriefPaneForNewProject(false));
  };

  const handleUploadFile = async (file: File): Promise<string | undefined> => {
    dispatch(setLoadingBriefForNewProject(true));

    try {
      const response = await uploadBriefForNewProject(
        file,
        activeWorkspaceUuid,
      );
      if (response) {
        const { result, campaignSuggestions, key } = response;
        dispatch(
          setBriefDataForNewProject({
            name: file.name,
            key,
            result,
            campaignSuggestions,
          }),
        );
        return response.result;
      }
    } finally {
      dispatch(setLoadingBriefForNewProject(false));
    }
  };

  const handleSaveRequirements = (requirements: string) => {
    const data = newProjectBriefData
      ? { ...newProjectBriefData, result: requirements }
      : {
          name: "",
          key: "",
          result: requirements,
        };
    dispatch(setBriefDataForNewProject(data));
  };

  const handleRemoveFile = () => {
    const data = newProjectBriefData
      ? {
          ...newProjectBriefData,
          name: "",
          key: "",
        }
      : null;

    dispatch(setBriefDataForNewProject(data));
  };

  return (
    <AddAIBriefPane
      onClose={handleCloseAddAIBriefPane}
      handleUploadFile={handleUploadFile}
      handleRemoveFile={handleRemoveFile}
      handleSaveRequirements={handleSaveRequirements}
      briefName={newProjectBriefData?.name ?? ""}
      briefContent={newProjectBriefData?.result ?? ""}
      isLoading={isNewProjectBriefLoading}
    />
  );
}
